goog.provide("shadow.js.shim.module$src$svg$wpp$content_actions$external_link_svg$default");
shadow.js.shim.module$src$svg$wpp$content_actions$external_link_svg$default = shadow.js.shim.module$src$svg$wpp$content_actions$external_link_svg.default;
